/**
 * @file
 * @prettier
 */

import { InitializeAddLoanPages } from "./AddLoanPages.js";

export function InitializeAddLoanStep2Page() {
  InitializeAddLoanPages();
}
